import { generateUUID } from '@/utils'
import { chatCompletionAPI, chatCustomURLAPI } from '@/proxy-request/api'
import { getStores } from '@/stores'
import { requestChatScrollToBottomAlways } from '@/pages/main/helpers/request-chat-scroll-to-bottom'
import type { ProxyRequestOpt } from './request'

export const saveUserTextToChatPanel = (text: string) => {
  const { agentV2Store } = getStores()
  if (text !== '' && text !== undefined && text !== null) {
    agentV2Store.chatLoadingState.loading = true
    agentV2Store.renderMsgList.push({
      id: generateUUID(),
      message_id: generateUUID(),
      sender: 'user',
      placement: 'end',
      content: [
        {
          type: 'block',
          typing: true,
          value: [
            {
              type: 'text',
              value: text
            }
          ],
          showAvatar: false
        }
      ]
    })
    setTimeout(() => {
      requestChatScrollToBottomAlways()
    }, 10)
  }
}

export const customApiCall = (opt: {
  body: Record<string, any>
  customUrl?: string
  opt?: ProxyRequestOpt
}): void => {
  const { agentV2Store } = getStores()

  chatCustomURLAPI({
    body: opt.body || {},
    customUrl: opt.customUrl,
    opt: {
      renderToChatPanel: true,
      requestType: 'sse',
      onBusinessError(err) {
        agentV2Store.chatLoadingState.loading = false
        opt.opt?.onBusinessError?.(err)
      },
      onConnect: () => {
        agentV2Store.chatLoadingState.loading = false
        opt.opt?.onConnect?.()
      },
      onDisconnect: () => {
        agentV2Store.chatLoadingState.loading = false
        opt.opt?.onDisconnect?.()
      },
      onError(err) {
        agentV2Store.chatLoadingState.loading = false
        console.error('sendMsg error', err)
        opt.opt?.onError?.(err)
      }
    }
  })
}

export const chatCompletion = (opt: {
  body: {
    text: string
    intention?: string
    platform?: number
    args?: any
  }
  opt?: ProxyRequestOpt
}): void => {
  const { text, intention, platform, args } = opt.body
  const { agentV2Store } = getStores()

  saveUserTextToChatPanel(text)
  const bodyData: any = {
    content: text,
    intention,
    args
  }
  if (platform !== undefined && platform !== null) {
    bodyData.platform = platform
  }

  chatCompletionAPI({
    body: bodyData,
    opt: {
      renderToChatPanel: true,
      requestType: 'sse',
      onBusinessError(err) {
        agentV2Store.chatLoadingState.loading = false
        opt.opt?.onBusinessError?.(err)
      },
      onConnect: () => {
        agentV2Store.chatLoadingState.loading = false
        opt.opt?.onConnect?.()
      },
      onDisconnect: () => {
        agentV2Store.chatLoadingState.loading = false
        opt.opt?.onDisconnect?.()
      },
      onError(err) {
        agentV2Store.chatLoadingState.loading = false
        console.error('sendMsg error', err)
        opt.opt?.onError?.(err)
      }
    }
  })
}
